import { Bell, Clock3, Package, Scissors, Users } from "lucide-react";

import { CrmPetController } from "../../../services/controllers/crmPet";
import { useCrmPet } from "../../../store/crmPet/useCrmPet";
import { CRM_PET_RULE_TABS } from "../constants";

const RULE_ICONS = {
  ALL: Users,
  ABSENT: Clock3,
  POTENTIAL_SUBSCRIBER: Bell,
  NO_PRODUCT: Package,
  NO_ADDITIONAL: Scissors,
};

export function CrmPetRuleTabs() {
  const CCrmPet = CrmPetController();
  const currentRule = useCrmPet((state) => state.data.filter.rule);
  const config = useCrmPet((state) => state.data.config);
  const isLoading = useCrmPet((state) => state.data.isLoading);

  return (
    <nav
      aria-label="Réguas do CRM Pet"
      className="overflow-x-auto rounded-lg border border-zinc-200 bg-white p-1.5 shadow-sm"
    >
      <div className="flex min-w-max items-center gap-1" role="tablist">
        {CRM_PET_RULE_TABS.map((tab) => {
          const Icon = RULE_ICONS[tab.value];
          const configuredRule = config.rules.find((rule) => rule.ruleCode === tab.value);
          const disabled = tab.value !== "ALL" && configuredRule?.active === false;
          const active = currentRule === tab.value;

          return (
            <button
              key={tab.value}
              type="button"
              role="tab"
              aria-selected={active}
              aria-controls="crm-pet-opportunities-table"
              disabled={disabled || isLoading}
              title={disabled ? `${tab.label} (régua inativa)` : tab.label}
              onClick={() => !active && CCrmPet.setRuleTab(tab.value)}
              className={`flex h-10 items-center gap-2 rounded-md border-none px-4 text-sm font-medium transition-colors ${active
                ? "bg-scale-500 text-white"
                : "bg-transparent text-gray-600 hover:bg-orange-50 hover:text-scale-600"
              } disabled:cursor-not-allowed disabled:opacity-50`}
            >
              <Icon aria-hidden="true" size={16} />
              <span>{tab.label}</span>
              {disabled && <span className="text-[10px] font-normal">Inativa</span>}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
